module.exports = __webpack_public_path__ + "media/images/icons/interaktivniMapaW-731930af848b28e1d7b8ee7214516817.svg";